import React from 'react';
import { Check } from 'lucide-react';
import { whyChooseUs } from '@/data/mock';

const WhyChooseUsSection = () => {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-cyan-500/5 to-teal-500/5 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/20 rounded-full text-cyan-600 text-sm font-medium mb-4">
              Why Us
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
              Why Clients <span className="bg-gradient-to-r from-cyan-500 to-teal-500 bg-clip-text text-transparent">Choose Us</span>
            </h2>
            <p className="text-slate-500 text-lg mb-10 leading-relaxed">
              We deliver clarity, governance, and execution discipline that transforms your technology investments into measurable business outcomes.
            </p>

            {/* Benefits List */}
            <div className="space-y-5">
              {whyChooseUs.map((benefit, index) => (
                <div
                  key={index}
                  className="group flex items-start gap-4 p-4 bg-slate-50 border border-slate-200 rounded-xl hover:border-cyan-400/50 hover:bg-white hover:shadow-lg hover:shadow-cyan-500/10 transition-all duration-300"
                >
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-cyan-500/25">
                    <Check className="w-5 h-5 text-white" />
                  </div>
                  <span className="text-slate-700 text-lg font-medium pt-0.5">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative aspect-square max-w-lg mx-auto">
              {/* Animated Rings */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-full h-full rounded-full border border-cyan-500/20 animate-pulse" />
              </div>
              <div className="absolute inset-8 flex items-center justify-center">
                <div className="w-full h-full rounded-full border border-cyan-500/30" style={{ animationDelay: '0.5s' }} />
              </div>
              <div className="absolute inset-16 flex items-center justify-center">
                <div className="w-full h-full rounded-full border border-teal-500/40" />
              </div>

              {/* Center Content */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center p-8 bg-white border border-slate-200 rounded-3xl shadow-2xl shadow-cyan-500/20">
                  <div className="text-6xl font-bold bg-gradient-to-r from-cyan-500 to-teal-500 bg-clip-text text-transparent mb-2">
                    25+
                  </div>
                  <p className="text-slate-800 text-lg font-semibold">Years Combined</p>
                  <p className="text-slate-500">Leadership Experience</p>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute top-8 right-8 p-4 bg-white border border-slate-200 rounded-2xl shadow-xl animate-float">
                <div className="text-2xl font-bold text-cyan-500">100%</div>
                <p className="text-slate-400 text-xs">Client Focused</p>
              </div>
              <div className="absolute bottom-8 left-8 p-4 bg-white border border-slate-200 rounded-2xl shadow-xl animate-float" style={{ animationDelay: '1s' }}>
                <div className="text-2xl font-bold text-teal-500">0</div>
                <p className="text-slate-400 text-xs">Hidden Costs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
